import { render, staticRenderFns } from "./AddressPicker.vue?vue&type=template&id=835c1f10&"
import script from "./AddressPicker.js?vue&type=script&lang=js&"
export * from "./AddressPicker.js?vue&type=script&lang=js&"
import style0 from "./AddressPicker.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports